<template>
  <section class="app-main">
      <Keep-alive >
          <router-view v-if="$route.meta.iskeepAlive"></router-view>
      </Keep-alive>
      <transition name="fade" mode="out-in">
        <router-view v-if="!$route.meta.iskeepAlive"></router-view>
      </transition>
  </section>
</template>

<script>
export default {
  name: 'AppMain',
  computed: {
    // key() {
    //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
    // }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue